module.exports = __webpack_public_path__ + "media/components/sessions/registration-form/img/gauge_icon1@2x-92bbc62c6e47fb730dd70df2d990e818.png";